import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';

// @source
import { FeedbackColector, RouteLink } from '../../components';
import { NotFoundRobot } from '../../media';
import * as Styled from './styled';

const initialState = {
  feedback: false,
};

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onToggleFeedback = this.onToggleFeedback.bind(this);
  }

  onToggleFeedback() {
    this.setState({ feedback: !this.state.feedback });
  }

  render() {
    return (
      <Styled.Scope>
        <EmptyState
          header="404. That’s an error."
          description={`The requested URL ${this.props.match.url} was not found on this server.`}
          imageUrl={NotFoundRobot}
          primaryAction={(
            <Button
              appearance="primary"
              onClick={() => this.props.history.goBack()}
            >
              Go back
            </Button>
          )}
          secondaryAction={(
            <Button component={RouteLink} href="/home">
              Back to homepage
            </Button>
          )}
          tertiaryAction={(
            <Button
              appearance="subtle-link"
              onClick={this.onToggleFeedback}
            >
              Report a problem
            </Button>
          )}
        />
        {this.state.feedback ? <FeedbackColector onClose={this.onToggleFeedback} /> : null}
      </Styled.Scope>
    );
  }
}

NotFound.propTypes = {
  history: PropTypes.shape().isRequired,
  match: PropTypes.shape().isRequired,
};

export default NotFound;
